<template>
  <div class="view-preferences">
    <h1 class="page-title">
      Preferências
      <small>Configure sua conta</small>
    </h1>

    <strong>Notificações por e-mail</strong>
    <b-form-checkbox
      v-for="(item, index) in emailNotificationOptions"
      :key="index"
      :id="`notify-${index}`"
      :name="`notify-${index}`"
      v-model="emailNotificationOptions[index].value"
    >
      {{ item.label }}
    </b-form-checkbox>

    <div class="mt-6">
      <strong>Preferências de vendas</strong>
      <b-form-checkbox
        v-for="(item, index) in sellingPreferencesOptions"
        :key="index"
        :id="`sale-${index}`"
        :name="`sale-${index}`"
        v-model="sellingPreferencesOptions[index].value"
      >
        {{ item.label }}
      </b-form-checkbox>
    </div>

    <div class="mt-6 col-8 pl-0">
      <strong>Privacidade - Coleta de dados e Cookies</strong>
      <b-form-checkbox
        v-for="(item, index) in privacyOptions"
        :key="index"
        :id="`privacy-${index}`"
        :name="`privacy-${index}`"
        v-model="privacyOptions[index].value"
      >
        {{ item.label }}
      </b-form-checkbox>
    </div>

    <button class="btn text-danger mt-9" type="button" @click="endAccount">
      Encerrar minha conta
    </button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      emailNotification: null,
      emailNotificationOptions: [
        {
          id: 1,
          value: false,
          label: "Receber e-mails com novidades da Blitzpay"
        },
        {
          id: 2,
          value: false,
          label: "Receber um e-mail quando alguém comentar nos meus produtos"
        },
        {
          id: 3,
          value: false,
          label: "Receber um e-mail quando um boleto for gerado"
        }
      ],
      sellingPreference: null,
      sellingPreferencesOptions: [
        {
          id: 1,
          value: false,
          label: "Habilitar vendas internacionais em outras moedas"
        },
        {
          id: 2,
          value: false,
          label:
            "Adicionar código de afiliação à página externa dos meus produtos"
        }
      ],
      privacyOptions: [
        {
          id: 1,
          value: false,
          label:
            "Ser responsável por transmitir aviso GDPR (novas políticas de coleta de dados europeia) aos meus clientes em todas as minhas páginas com script do Blitzpay instalado."
        }
      ]
    };
  },
  methods: {
    endAccount() {},
    updatePreferences() {}
  }
};
</script>
